import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, Component, ViewChild, ContentChildren, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i5 from '@appkit4/angular-components/dropdown-list-item';
import { DropdownListItemComponent, DropdownListItemModule } from '@appkit4/angular-components/dropdown-list-item';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { convertToRem, convertToRelativeRem, convertToRelativePx } from '@appkit4/angular-components/utils';
import * as i1 from '@appkit4/angular-components/dropdown';
import { DropdownService } from '@appkit4/angular-components/dropdown';
import * as i2 from '@appkit4/angular-api';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@appkit4/angular-components/tag';
import { TagModule } from '@appkit4/angular-components/tag';
import * as i6 from '@appkit4/angular-components/loading';
import { LoadingModule } from '@appkit4/angular-components/loading';

const COMBOBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ComboboxComponent),
    multi: true,
};
class ComboboxComponent {
    constructor(dropdownService, el, render, cdr, localizationConfig) {
        this.dropdownService = dropdownService;
        this.el = el;
        this.render = render;
        this.cdr = cdr;
        this.localizationConfig = localizationConfig;
        this.selectType = "single";
        this.optionName = 'label';
        this.optionValue = 'value';
        this.list = [];
        this.showDeleteIcon = false;
        this.showSelectAll = false;
        this.showMultipleTags = false;
        this.maxHeight = 700;
        this.showLoading = false;
        this.showAllSelectedTag = true;
        this.onClose = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onFilterResult = new EventEmitter();
        this.showList = false;
        this.showBlankPage = false;
        this.allowDataLoad = true;
        this.originalList = [];
        this.resultList = {};
        this.grouped = false;
        this.finalItems = [];
        this.typingStatus = false;
        this.showTag = false;
        this.showDriverLine = false;
        this.normalTempItem = {};
        this.groupedTempItem = {};
        this.hidePlaceholder = false;
        this.changeSubscriptionArray$ = [];
        this.value = "";
        this.iconId = "";
        this.onModelChange = () => { };
        this.onModelTouched = () => { };
        this.focusInput = false;
        this.comboboxContainerStyle = {};
        this.inputStyle = {};
        this.inputChangeSubject = new Subject();
        this.getFocusableElement = (findElement, element, isNext = true) => {
            const controls = `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
        [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])`;
            let focusable = findElement?.querySelectorAll(controls);
            const index = Array.prototype.indexOf.call(Array.from(focusable), element);
            return isNext ? Array.from(focusable)[index + 1] : Array.from(focusable)[index - 1];
        };
        this.inputChangeSubject.pipe(debounceTime(0) // Adjust this value as needed
        ).subscribe((value) => {
            this.handleInputChange(value);
        });
    }
    onInputChange(event, isChangeWidth = false) {
        this.inputChangeSubject.next(event);
        if (this.showMultipleTags && isChangeWidth) {
            this.render.setStyle(event.target, 'width', convertToRem((event.target.value.length + 2) * 8 + 2));
            this.adjustPostionBySelectedTag();
        }
        this.setInputMaxWidth();
        if (this.showMultipleTags && this.inputViewChild?.nativeElement.value === '' && this.finalItems.length === 0)
            if (this.inputViewChild)
                this.inputViewChild.nativeElement.style.width = '';
    }
    ngOnInit() {
        this.translationSubscription$ = this.localizationConfig.translationObserver.subscribe(() => {
            if (this.selectType === 'single') {
                this._placeholder = this.customPlaceholder;
            }
            this.setComboboxFieldValue();
            this.selectAllItem = { ...this.selectAllItem, label: this.getLabel('selectAll') };
        });
        this._placeholder = this.customPlaceholder;
        this.comboboxContainerStyle = {
            maxHeight: this.showMultipleTags ? convertToRem(this.maxHeight) : 'none'
        };
        this.selectAllItem = {
            value: "selectAll",
            label: this.getLabel('selectAll'),
            showCheckbox: true,
        };
        if (!this.listId) {
            this.listId =
                "list" +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    Date.now();
        }
        if (!this.comboboxId) {
            this.comboboxId =
                "combobox" +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    Date.now();
        }
        this.iconId =
            "icon" +
                String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                Date.now();
    }
    ngOnChanges(changes) {
        let change = changes?.['list'];
        if (changes['list'] && change.currentValue) {
            this.list = [...change.currentValue];
            if (this.list) {
                for (let i = 0; i < this.list.length; i++) {
                    if (this.list[i].items) {
                        this.grouped = true;
                        //   for (let j = 0; j < this.list[i].items.length; j++) {
                        //       this.newMultipleArry.push(this.list[i].items[j]);
                        //   }
                    }
                }
                Promise.resolve().then(() => {
                    this.setInitialOptionNameAndValue();
                });
            }
            if (this.allowDataLoad) {
                this.originalList = [...change.currentValue];
            }
            else {
                this.allowDataLoad = true;
            }
            Promise.resolve().then(() => {
                this.changeSubscriptionArray$.forEach((item) => {
                    item.unsubscribe();
                });
                this.changeSubscriptionArray$ = [];
                this.comboboxListItemArray
                    ?.toArray()
                    .forEach((obj) => {
                    const a = obj.onSelectItem.subscribe((event) => {
                        this.onSelectedChange(event, obj);
                    });
                    this.changeSubscriptionArray$.push(a);
                });
            });
        }
        if (changes['required']?.currentValue) {
            this.required = changes['required']?.currentValue;
        }
        if (changes['maxHeight']?.currentValue || changes['showMultipleTags']?.currentValue) {
            this.comboboxContainerStyle = {
                maxHeight: convertToRem(changes['maxHeight']?.currentValue || this.maxHeight)
            };
        }
        if (changes['showMultipleTags']?.currentValue) {
            const inputElement = this.inputViewChild?.nativeElement;
            if (inputElement?.value !== '') {
                const width = ((inputElement?.value.length + 2) * 8 + 2);
                this.inputStyle = {
                    width: convertToRem(width)
                };
            }
        }
        else if (changes['showMultipleTags']?.currentValue === false) {
            this.inputStyle = {};
            this.setSearchText();
            this.adjustPostionBySelectedTag(true);
        }
        if (changes['showSelectAll']?.currentValue) {
            if ((this.grouped && this.originalList?.[0].items?.every(item => item.checked))
                || (!this.grouped && this.originalList?.every(item => item.checked))) {
                if (this.selectAllItem)
                    this.selectAllItem.checked = true;
            }
            else {
                if (this.selectAllItem)
                    this.selectAllItem.checked = false;
            }
        }
        if ((this.grouped && this.originalList?.[0].items?.every(item => item.checked))
            || (!this.grouped && this.originalList?.every(item => item.checked))) {
            this.tagText = ((this.showSelectAll && !this.showMultipleTags) || (this.showMultipleTags && this.showAllSelectedTag)) ? this.getLabel('allSelectedMessage') : this.getSelectionMessage(this.finalItems.length);
        }
        this.adjustPostionBySelectedTag();
    }
    ngOnDestroy() {
        this.translationSubscription$?.unsubscribe();
    }
    get _noResultMsg() {
        return this.noResultMsg || this.noResultMsg === "" ? this.noResultMsg : this.getLabel('noResultMessage');
    }
    get customPlaceholder() {
        return this.placeholder || this.placeholder === "" ? this.placeholder : this.getLabel('comboboxPlaceholder');
    }
    getSelectionMessage(count) {
        return this.localizationConfig.translation ? this.localizationConfig.translation['selectionMessage']?.replaceAll('{0}', String(count)) : null;
    }
    getResultMessage(count) {
        return this.localizationConfig.translation?.aria ? this.localizationConfig.translation?.aria['resultMessage']?.replaceAll('{0}', String(count)) : null;
    }
    getLabel(labelKey) {
        return this.localizationConfig.translation ? this.localizationConfig.translation[labelKey] : null;
    }
    getAriaLabel(labelKey) {
        return this.localizationConfig.translation?.aria ? this.localizationConfig.translation.aria[labelKey] : null;
    }
    addClassToElement(element, className) {
        if (!element.classList?.contains(className))
            element.classList.add(className);
    }
    onToggle(event) {
        this.removeKeyboard();
        if (event.composedPath()[0]?.id === this.iconId) {
            this.onClickToggleIcon(event);
            return;
        }
        this.adjustPostionBySelectedTag();
        this.show();
        this.updateIcon();
        this.inputViewChild?.nativeElement.focus();
        if (this.selectType === "multiple" && this.showTag) {
            this.showDeleteIcon = true;
            this.showDriverLine = true;
        }
        else if (this.inputViewChild?.nativeElement.value.length > 0) {
            this.showDriverLine = true;
        }
        else {
            this.showDriverLine = false;
            this.showDeleteIcon = false;
            this.showBlankPage = false;
        }
        if (this.inputViewChild?.nativeElement.value.length > 0 &&
            this.searchText &&
            this.searchText.length > 0) {
            this.keywordFilter(event);
        }
        else {
            let length = this.dropdownService.getListLength(this.grouped, this.list);
            this.resultStatus = this.getResultMessage(length);
            // this.commonNullFilter(event); Avoid performance consume
            this.showBlankPage = false;
        }
    }
    closeTag(event, itemSelected) {
        event?.originEvent?.stopPropagation();
        let selectTemp = this.comboboxListItemArray
            ?.toArray()
            .find((o) => o.item[this.optionValue] === itemSelected[this.optionValue]);
        this.finalItems = this.finalItems.filter(item => item[this.optionValue] !== itemSelected[this.optionValue]);
        if (selectTemp) {
            selectTemp.onSelectItem.next({
                originEvent: event,
                selected: this.finalItems.find(item => item[this.optionValue] === itemSelected[this.optionValue])
            });
        }
        this.inputViewChild?.nativeElement.focus();
        this.updateValueForMultipleTags(this.finalItems);
        this.onModelChange(this.finalItems);
        this.setComboboxFieldValue();
        if (this.showTag)
            this.hidePlaceholder = true;
        if (!this.showTag && ((this.searchText === '') || this.searchText == undefined)) {
            this.hidePlaceholder = false;
        }
        else if (!this.showTag && this.searchText && this.searchText.length > 0) {
            this.hidePlaceholder = true;
        }
        this.setInputMaxWidth();
        this.resetInputWidth();
    }
    resetInputWidth() {
        if (this.showMultipleTags && this.finalItems.length === 0)
            if (this.inputViewChild)
                this.inputViewChild.nativeElement.style.width = '';
    }
    updateValueForMultipleTags(obj) {
        if (obj !== undefined &&
            obj !== null &&
            Object.keys(obj).length !== 0) {
            if (obj.length) {
            }
            else {
                obj = Array.from(new Array(obj));
                this.finalItems = obj;
            }
            this.removeOriginalSelectedItems(true);
            this.updateCheckedStatus(obj);
            let l = this.finalItems.length;
            if (this.grouped && l > 0) {
                this.groupedTempItem = this.finalItems[l - 1];
            }
            else if (!this.grouped && l > 0) {
                this.normalTempItem = this.finalItems[l - 1];
            }
            this.adjustPostionBySelectedTag();
        }
        else if (this.finalItems.length === 0) {
            this.finalItems = [];
            this.removeSelectedItems();
        }
    }
    adjustPostionBySelectedTag(withoutReturn = false) {
        if (!this.showMultipleTags && !withoutReturn)
            return;
        setTimeout(() => {
            const inputArea = this.inputArea.nativeElement;
            if (inputArea.getBoundingClientRect().height > 48)
                this.addClassToElement(inputArea, 'overflow-line');
            else
                inputArea.classList.remove('overflow-line');
            this.render.setStyle(this.comboboxList.nativeElement, 'top', convertToRelativeRem(inputArea.getBoundingClientRect().height + convertToRelativePx(8)));
        }, 50);
    }
    commonNullFilter(event) {
        let result = [];
        if (this.selectType === "single") {
            result = this.dropdownService.filterOption("", this.originalList, this.optionName);
        }
        else if (this.selectType === "multiple") {
            result = this.dropdownService.filterGroupOption("", this.originalList, this.optionName, this.optionValue);
        }
        this.showBlankPage = result.length === 0;
        this.onFilterResult.emit({
            originEvent: event,
            searchStr: "",
            result: result,
        });
        this.resultList = result;
        this.allowDataLoad = false;
    }
    onClickToggleIcon(event) {
        if (this.grouped) {
            this.groupDataScroll();
        }
        else {
            this.normalDataScroll();
        }
        this.showList = !this.showList;
        if (this.showList)
            this.bindDocumentClickListener();
        else
            this.onClose.emit(event);
        this.updateIcon();
        this.inputViewChild?.nativeElement.focus();
        if (this.searchText && this.searchText.length > 0) {
            this.keywordFilter(event);
        }
        // else { Avoid performance consume
        //     this.commonNullFilter(event);
        // }
    }
    updateIcon() {
        setTimeout(() => {
            if (this.showList) {
                this.iconChevron.nativeElement.classList.add("up");
            }
            else {
                this.iconChevron.nativeElement.classList.remove("up");
            }
        }, 0);
    }
    writeValue(obj) {
        if (this.inputViewChild && this.inputViewChild.nativeElement) {
            switch (this.selectType) {
                case "single":
                    if (obj !== undefined &&
                        obj !== null &&
                        Object.keys(obj).length !== 0) {
                        if (this.grouped) {
                            this.dropdownService.setGroupedDataCheckedStatus(this.list, this.optionValue, [obj]);
                            if (this.inputViewChild)
                                this.inputViewChild.nativeElement.value =
                                    obj[this.optionName];
                            this.groupedTempItem = obj;
                        }
                        else {
                            this.normalTempItem = obj;
                            this.list.forEach((litem) => {
                                if (litem[this.optionValue] ===
                                    obj[this.optionValue]) {
                                    litem.checked = true;
                                }
                            });
                            this.value = obj[this.optionName];
                            if (this.inputViewChild)
                                this.inputViewChild.nativeElement.value =
                                    obj[this.optionName];
                        }
                        this.showDeleteIcon = true;
                        this.showDriverLine = true;
                        this.hidePlaceholder = true;
                    }
                    else {
                        this.value = "";
                        this.showDeleteIcon = false;
                        if (this.inputViewChild)
                            this.inputViewChild.nativeElement.value = "";
                    }
                    break;
                case "multiple":
                    if (obj !== undefined &&
                        obj !== null &&
                        Object.keys(obj).length !== 0) {
                        if (obj.length) {
                        }
                        else {
                            obj = Array.from(new Array(obj));
                            this.finalItems = obj;
                        }
                        this.removeSelectedItems();
                        this.updateCheckedStatus(obj);
                        this.setComboboxFieldValue();
                        let l = this.finalItems.length;
                        if (this.grouped && l > 0) {
                            this.groupedTempItem = this.finalItems[l - 1];
                        }
                        else {
                            this.normalTempItem = this.finalItems[l - 1];
                        }
                        this.adjustPostionBySelectedTag();
                    }
                    else if (this.list && ((this.grouped && this.originalList?.[0].items?.every(item => !item.checked))
                        || (!this.grouped && this.originalList?.every(item => !item.checked)))) {
                        this.finalItems = [];
                        this.removeSelectedItems();
                        this.setComboboxFieldValue();
                    }
                    this.hidePlaceholder = this.showTag;
                    this.setSearchText();
                    break;
            }
            this.setNextMoved('click');
        }
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    removeSelectedItems() {
        if (this.grouped) {
            // for (let i = 0, len = this.list.length; i < len; ++i) {
            //     let itemsArray = this.list[i].items;
            //     itemsArray.forEach((item) => {
            //         item.checked = false;
            //     });
            // }
            this.dropdownService.updateGroupedDataCheckedStatus(this.originalList);
        }
        else {
            // if (this.list) {
            //     this.list.forEach((item) => {
            //         item.checked = false;
            //     });
            // }
            this.dropdownService.updateNormalDataCheckedStatus(this.originalList);
        }
    }
    removeOriginalSelectedItems(needNotInFinalItems = false) {
        if (this.grouped) {
            for (let i = 0, len = this.originalList.length; i < len; ++i) {
                let itemsArray = this.originalList[i].items;
                itemsArray.forEach((item) => {
                    if (needNotInFinalItems && item.checked &&
                        !this.finalItems.find((fitem) => fitem[this.optionValue] === item[this.optionValue]))
                        item.checked = false;
                });
            }
        }
        else {
            if (this.originalList) {
                this.originalList.forEach((item) => {
                    if (needNotInFinalItems && item.checked &&
                        !this.finalItems.find((fitem) => fitem[this.optionValue] === item[this.optionValue]))
                        item.checked = false;
                });
            }
        }
        this.originalList = [...this.originalList];
    }
    updateCheckedStatus(options) {
        this.finalItems = options;
        if (this.selectType === "multiple") {
            if (this.grouped) {
                this.dropdownService.setGroupedDataCheckedStatus(this.list, this.optionValue, options);
            }
            else {
                this.dropdownService.setNormalDataCheckedStatus(this.list, this.optionValue, options);
            }
        }
    }
    keywordFilter(event) {
        let result = [];
        let searchText = this.searchText?.toUpperCase() || "";
        let filterList = [...this.originalList];
        if (this.grouped) {
            result = this.dropdownService.filterGroupOption(searchText, filterList, this.optionName, this.optionValue);
        }
        else {
            result = this.dropdownService.filterOption(searchText, filterList, this.optionName);
        }
        if (result.length > 0) {
            this.showBlankPage = false;
        }
        else {
            this.showBlankPage = true;
        }
        this.onFilterResult.emit({
            originEvent: event,
            searchStr: this.searchText,
            result: result,
        });
        this.resultList = result;
        this.allowDataLoad = false;
    }
    handleInputChange(event) {
        event.stopPropagation();
        event.preventDefault();
        this.typingStatus = true;
        this.searchText = this.inputViewChild?.nativeElement.value;
        // this.onModelChange(this.searchText); 
        if (this.searchText && this.searchText.length > 0) {
            this.searchText = this.inputViewChild?.nativeElement.value.trim();
            this.hidePlaceholder = true;
            this.showDriverLine = true;
            this.show();
            this.updateIcon();
            this.keywordFilter(event);
        }
        else {
            let result = [];
            if (this.selectType === "single") {
                this.hidePlaceholder = false;
                result = this.dropdownService.filterOption("", this.originalList, this.optionName);
            }
            else if (this.selectType === "multiple") {
                result = this.dropdownService.filterGroupOption("", this.originalList, this.optionName, this.optionValue);
                if (this.showTag) {
                    this.hidePlaceholder = true;
                    this.showDeleteIcon = true;
                    this.showDriverLine = true;
                }
                else {
                    this.showDriverLine = false;
                    this.showDeleteIcon = false;
                    this.hidePlaceholder = false;
                }
            }
            this.showBlankPage = result.length === 0;
            this.onFilterResult.emit({
                originEvent: event,
                searchStr: "",
                result: result,
            });
            this.resultList = result;
        }
        this.allowDataLoad = false;
        this.inputViewChild?.nativeElement.focus();
    }
    onClickOut(event) {
        // ccheck if click on current element
        if (event.target.shadowRoot) {
            if (!this.showList) {
                return;
            }
            // check before go through path element to reduce time
            const path = event.composedPath();
            let self = false;
            for (let i = 0; i < 5; i++) {
                if (path[i] &&
                    path[i].id &&
                    path[i].id.indexOf(this.comboboxId) !== -1) {
                    self = true;
                    break;
                }
            }
            if (self) {
                return;
            }
        }
        this.hide(event);
    }
    show() {
        if (this.grouped) {
            this.groupDataScroll();
        }
        else {
            this.normalDataScroll();
        }
        this.showList = true;
        this.adjustPostionBySelectedTag();
        this.bindDocumentClickListener();
    }
    hide(event, isClickOut = false) {
        const isShow = this.showList;
        this.showList = false;
        if (this.inputViewChild && ((!this.searchText || this.searchText === '')
            || isClickOut)) {
            this.inputViewChild.nativeElement.value = "";
        }
        if (isClickOut) {
            this.searchText = '';
            this.hidePlaceholder = this.showTag;
        }
        if (this.selectType === "single") {
            let index;
            let selectedGroupedItem;
            if (this.grouped) {
                this.originalList.forEach((item) => {
                    item.items.forEach((subItem) => {
                        if (subItem.checked) {
                            selectedGroupedItem = subItem;
                            this.hidePlaceholder = true;
                        }
                    });
                });
                if (selectedGroupedItem &&
                    selectedGroupedItem[this.optionName]) {
                    if (this.inputViewChild)
                        this.inputViewChild.nativeElement.value =
                            selectedGroupedItem[this.optionName];
                    this.showDeleteIcon = true;
                    this.showDriverLine = true;
                    this.hidePlaceholder = true;
                }
                else {
                    this.showDeleteIcon = false;
                    this.showDriverLine = false;
                }
            }
            else {
                index = this.originalList.findIndex((item) => item.checked);
                if (index > -1) {
                    if (this.inputViewChild)
                        this.inputViewChild.nativeElement.value =
                            this.originalList[index][this.optionName];
                    this.showDeleteIcon = true;
                    this.showDriverLine = true;
                    this.hidePlaceholder = true;
                }
                else {
                    this.showDeleteIcon = false;
                    this.showDriverLine = false;
                    this.hidePlaceholder = false;
                }
            }
        }
        if (this.selectType === "multiple") {
            if (this.showTag) {
                this.showDriverLine = true;
                this.showDeleteIcon = true;
                this.hidePlaceholder = true;
            }
            else {
                this.showDriverLine = false;
                this.showDeleteIcon = false;
                this.hidePlaceholder = false;
            }
        }
        if (this.searchText && this.searchText !== '') {
            this.showDriverLine = true;
            this.hidePlaceholder = true;
        }
        this.removeKeyboard();
        if (isShow)
            this.onClose.emit(event);
        this.updateIcon();
        setTimeout(() => {
            this.commonNullFilter(event);
        }, 300);
        if (isClickOut)
            this.unbindDocumentClickListener();
    }
    bindDocumentClickListener() {
        if (!this.comboboxClickListener) {
            this.comboboxClickListener = this.render.listen(window, "click", (event) => {
                const target = event.target;
                if (target.shadowRoot) {
                    const path = event.composedPath();
                    const self = path.slice(0, 5).some(item => item?.id &&
                        (item.id.includes(this.comboboxId) || item.id.includes(this.listId)));
                    if (!self) {
                        this.hide(event, true);
                    }
                }
                else {
                    if ((!this.el.nativeElement?.contains(target) &&
                        !this.comboboxList.nativeElement?.contains(target) &&
                        !target.parentNode?.classList?.contains('combobox-tag-item'))) {
                        this.hide(event, true);
                    }
                }
            });
        }
    }
    unbindDocumentClickListener() {
        if (this.comboboxClickListener) {
            this.comboboxClickListener();
            this.comboboxClickListener = null;
        }
    }
    onClickDeleteIncon(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.inputViewChild)
            this.inputViewChild.nativeElement.value = "";
        this.searchText = "";
        this.hidePlaceholder = false;
        this.onModelChange("");
        this.showDeleteIcon = false;
        this.showDriverLine = false;
        this.normalTempItem = {};
        this.currentActiveEle = null;
        if (this.selectType === "single") {
            this.showBlankPage = false;
            this.originalList.forEach((childItem) => {
                if (this.grouped) {
                    childItem.items.forEach((item) => {
                        item.checked = false;
                        item.focused = false;
                    });
                }
                else {
                    childItem.checked = false;
                    childItem.focused = false;
                }
            });
            let result = this.dropdownService.filterOption("", this.originalList, this.optionName);
            this.list = [...this.originalList];
            this.onModelChange({});
            this.onFilterResult.emit({
                originEvent: event,
                searchStr: "",
                result: result,
            });
            this.resultList = result;
        }
        else if (this.selectType === "multiple") {
            this.showBlankPage = false;
            this.showTag = false;
            if (this.grouped) {
                let result;
                if (this.inputViewChild)
                    this.inputViewChild.nativeElement.value = "";
                if (this.selectAllItem.checked) {
                    this.selectAllItem.checked = false;
                    this.dropdownService.updateGroupedDataCheckedStatus(this.originalList);
                    // result = this.dropdownService.filterGroupOption("", this.originalList, this.optionName, this.optionValue);
                    result = [...this.originalList];
                }
                else {
                    this.dropdownService.updateGroupedDataCheckedStatus(this.originalList);
                    // result = this.dropdownService.filterGroupOption("", this.originalList, this.optionName, this.optionValue);
                    result = [...this.originalList];
                }
                this.finalItems = [];
                this.tagText = '';
                this.onModelChange(this.finalItems);
                this.setComboboxFieldValue();
                this.onFilterResult.emit({
                    originEvent: event,
                    searchStr: "",
                    result: result,
                });
                this.resultList = result;
            }
            else {
                let result;
                if (this.selectAllItem.checked) {
                    this.selectAllItem.checked = false;
                    this.dropdownService.updateNormalDataCheckedStatus(this.originalList);
                    result = [...this.originalList];
                    // result = this.dropdownService.filterOption("", this.originalList, this.optionName);
                }
                else {
                    this.dropdownService.updateNormalDataCheckedStatus(this.originalList);
                    result = [...this.originalList];
                    // result = this.dropdownService.filterOption("", this.originalList, this.optionName);
                }
                this.finalItems = [];
                this.tagText = '';
                this.onModelChange(this.finalItems);
                this.setComboboxFieldValue();
                this.onFilterResult.emit({
                    originEvent: event,
                    searchStr: "",
                    result: result,
                });
                this.resultList = result;
            }
            if (this.showMultipleTags && this.inputViewChild?.nativeElement.value === '' && this.finalItems.length === 0)
                if (this.inputViewChild)
                    this.inputViewChild.nativeElement.style.width = '';
        }
        this.cdr.detectChanges();
        this.inputViewChild?.nativeElement.focus();
        this.allowDataLoad = false;
    }
    onKeydownDeleteIcon(event) {
        let keyCode = event.keyCode;
        switch (keyCode) {
            case 13: //enter
            case 32: //space
                this.onClickDeleteIncon(event);
                break;
        }
    }
    onSelectedChange(event, operationItemInstance) {
        if (this.selectType === "single") {
            this.onSingleSelectedChange(event, operationItemInstance);
        }
        else if (this.selectType === "multiple") {
            this.onMultipleSelectedChange(event, operationItemInstance);
        }
        this.updateIcon();
        this.adjustPostionBySelectedTag();
        const inputElement = this.inputViewChild?.nativeElement;
        if (this.finalItems.length === 0) {
            if (this.showMultipleTags && inputElement)
                inputElement.style.width = '';
        }
        if (this.showMultipleTags && inputElement?.value !== '')
            inputElement && this.render.setStyle(inputElement, 'width', convertToRem((inputElement.value.length + 2) * 8 + 2));
        else {
            if (this.showMultipleTags && this.finalItems.length === 0 && inputElement)
                inputElement.style.width = '';
        }
        this.resetInputWidth();
        this.cdr.detectChanges();
        if (this.showMultipleTags) {
            this.setSearchText();
            if (this.searchText && this.searchText !== '')
                this.inputViewChild.nativeElement.classList.remove('input-width');
        }
        this.inputViewChild?.nativeElement.focus();
    }
    onSingleSelectedChange(event, operationItemInstance) {
        this.hide(event);
        this.typingStatus = false;
        let actionItem = event.selected;
        if (this.inputViewChild)
            this.inputViewChild.nativeElement.value = actionItem[this.optionName];
        this.searchText = "";
        this.hidePlaceholder = true;
        this.showDeleteIcon = true;
        this.showDriverLine = true;
        this.onModelChange(actionItem);
        if (event.eventType && event.eventType === "keydown") {
        }
        else {
            this.removeKeyboard();
        }
        this.list.forEach((childItem) => {
            if (this.grouped) {
                childItem.items.forEach((item) => {
                    if (item[this.optionValue] === actionItem[this.optionValue]) {
                        item.checked = true;
                    }
                    else {
                        item.checked = false;
                    }
                });
            }
            else {
                if (childItem[this.optionValue] === actionItem[this.optionValue]) {
                    if (!childItem.checked)
                        childItem.checked = true;
                }
                else {
                    childItem.checked = false;
                }
            }
        });
        this.originalList.forEach((childItem) => {
            if (this.grouped) {
                childItem.items.forEach((item) => {
                    if (item[this.optionValue] === actionItem[this.optionValue]) {
                        item.checked = true;
                    }
                    else {
                        item.checked = false;
                    }
                });
            }
            else {
                if (childItem[this.optionValue] === actionItem[this.optionValue]) {
                    if (!childItem.checked)
                        childItem.checked = true;
                }
                else {
                    childItem.checked = false;
                }
            }
        });
        this.onSelect.emit({
            originEvent: event,
            selected: actionItem,
        });
        operationItemInstance.onUpdate(event, actionItem, event.eventType);
        this.onClose.emit(event.originEvent);
    }
    onMultipleSelectedChange(event, operationItemInstance) {
        this.typingStatus = false;
        let item = event.selected;
        this.hidePlaceholder = true;
        if (item) {
            if (item.checked) {
                this.deleteItem(item);
                item.checked = false;
            }
            else {
                item.checked = true;
                this.addItem(item);
            }
        }
        this.setComboboxFieldValue();
        if (this.showTag)
            this.hidePlaceholder = true;
        if (!this.showTag && ((this.searchText === '') || this.searchText == undefined)) {
            this.hidePlaceholder = false;
        }
        else if (!this.showTag && this.searchText && this.searchText.length > 0) {
            this.hidePlaceholder = true;
        }
        // if (this.grouped) {
        //     this.groupedTempItem = item;
        // }
        // this.inputViewChild.nativeElement.focus();
        this.onModelChange(this.finalItems);
        if (event.eventType && event.eventType === "keydown") {
        }
        else {
            this.removeKeyboard();
        }
        this.onSelect.emit({
            originEvent: event,
            selected: this.finalItems,
        });
        operationItemInstance.onUpdate(event, this.finalItems, event.eventType);
    }
    onClickSelectAll(event) {
        let item = event.selected;
        let tempList = [...this.originalList];
        if (this.grouped) {
            if (item.checked) {
                item.checked = false;
                let temArray = [];
                for (let i = 0; i < tempList.length; i++) {
                    let items = tempList[i].items;
                    for (let j = 0; j < items.length; j++) {
                        if (!items[j].disabled) {
                            items[j].checked = false;
                        }
                        else if (items[j].disabled && items[j].checked) {
                            temArray.push(items[j]);
                        }
                    }
                }
                this.finalItems = [...temArray];
            }
            else {
                item.checked = true;
                let temArray = [];
                for (let i = 0; i < tempList.length; i++) {
                    let items = tempList[i].items;
                    for (let j = 0; j < items.length; j++) {
                        if (!items[j].disabled) {
                            items[j].checked = true;
                            temArray.push(items[j]);
                        }
                        else if (items[j].checked) {
                            temArray.push(items[j]);
                        }
                    }
                }
                this.finalItems = [...temArray];
            }
        }
        else {
            if (item.checked) {
                let selectedArr = [];
                item.checked = false;
                tempList.forEach((item) => {
                    if (!item.disabled) {
                        item.checked = false;
                    }
                    else if (item.disabled && item.checked) {
                        selectedArr.push(item);
                    }
                });
                this.finalItems = [...selectedArr];
                this.list = [...tempList];
            }
            else {
                let selectedArr = [];
                item.checked = true;
                tempList.forEach((item) => {
                    if (!item.disabled) {
                        item.checked = true;
                        selectedArr.push(item);
                    }
                    else if (item.checked) {
                        selectedArr.push(item);
                    }
                });
                this.list = [...tempList];
                this.finalItems = [...selectedArr];
            }
        }
        this.onModelChange(this.finalItems);
        this.setComboboxFieldValue();
        if (this.showTag)
            this.hidePlaceholder = true;
        if (!this.showTag && ((this.searchText === '') || this.searchText == undefined)) {
            this.hidePlaceholder = false;
        }
        else if (!this.showTag && this.searchText && this.searchText.length > 0) {
            this.hidePlaceholder = true;
        }
        // if (event.eventType && event.eventType === "keydown" || event.type === "keydown") {
        // } else {
        //     this.removeKeyboard();
        // }
        this.adjustPostionBySelectedTag();
        this.onSelect.emit({
            originEvent: event,
            selected: this.finalItems,
        });
        if (this.showMultipleTags && item.value === 'selectAll' && !item.checked) {
            this.tagText = '';
        }
        this.cdr.detectChanges();
        this.inputViewChild?.nativeElement.focus();
        this.setSearchText();
    }
    setSearchText() {
        if (this.inputViewChild?.nativeElement && this.searchText)
            this.inputViewChild.nativeElement.value = this.searchText;
    }
    deleteItem(item) {
        for (let i = 0; i < this.finalItems.length; i++) {
            if (item[this.optionValue] === this.finalItems[i][this.optionValue]) {
                this.finalItems.splice(i, 1);
            }
        }
    }
    addItem(item) {
        let index = this.finalItems.findIndex((f) => f[this.optionValue] === item[this.optionValue]);
        if (!(index > -1)) {
            this.finalItems.push(item);
        }
    }
    setComboboxFieldValue() {
        let s = this.finalItems.length;
        let disabledLen = this.dropdownService.getDisabledLen(this.grouped, this.originalList).disabledLen;
        let disabledItems = this.dropdownService.getDisabledLen(this.grouped, this.originalList).disabledItems;
        if (!this.showSelectAll && this.originalList && !this.showMultipleTags) {
            let l = this.dropdownService.getListLength(this.grouped, this.originalList);
            if (s > 1 && s <= l) {
                this.showTag = true;
                this.showDriverLine = true;
                this.tagText = this.getSelectionMessage(s);
                this._placeholder = "";
                this.showDeleteIcon = true;
                this.selectAllItem.checked = false;
            }
            else if (s === 1) {
                this.showTag = true;
                this.showDriverLine = true;
                this.tagText = this.getSelectionMessage(s);
                this._placeholder = "";
                this.showDeleteIcon = true;
                this.selectAllItem.checked = false;
            }
            else if (s === 0) {
                // this.hidePlaceholder = false;
                this.showTag = false;
                this.showDriverLine = false;
                this.showDeleteIcon = false;
                this.selectAllItem.checked = false;
                this._placeholder = this.customPlaceholder;
            }
        }
        else if ((this.showSelectAll || this.showMultipleTags) && this.originalList) {
            let availCheckedLen = this.dropdownService.getNonDisabledLength(this.grouped, this.originalList);
            let originalL = this.dropdownService.getOrinalLength(this.grouped, this.originalList);
            let availCheckedItems = this.dropdownService.getNonDisabledItems(this.grouped, this.originalList);
            let availAllChecked = availCheckedItems.findIndex((item) => item.checked === false);
            let includeDis;
            let result = disabledItems.filter((disItem) => this.finalItems.findIndex((fitem) => fitem[this.optionValue] ===
                disItem[this.optionValue]) > -1);
            if (result.length > 0) {
                includeDis = true;
            }
            else {
                includeDis = false;
            }
            if ((s > 1 && s < originalL && availCheckedLen === originalL) ||
                (s > 1 && s < originalL && availAllChecked > -1)) {
                this.showDeleteIcon = true;
                this.showTag = true;
                this.showDriverLine = true;
                this.tagText = this.getSelectionMessage(s);
                this._placeholder = "";
                this.selectAllItem.checked = false;
            }
            else if (s === 1 && s === originalL) {
                this.showDeleteIcon = true;
                this.showDriverLine = true;
                this.showTag = true;
                this.tagText = this.getLabel('allSelectedMessage');
                this._placeholder = "";
                this.selectAllItem.checked = true;
            }
            else if (s === 1 && s !== originalL) {
                this.showDeleteIcon = true;
                this.showDriverLine = true;
                this.showTag = true;
                this.tagText = this.getSelectionMessage(s);
                this._placeholder = "";
                this.selectAllItem.checked = false;
            }
            else if ((s === originalL && availCheckedLen === originalL) ||
                (originalL === s && includeDis) ||
                (this.showMultipleTags && (s === availCheckedLen ||
                    this.finalItems.filter(item => !item.disabled).length === availCheckedLen))) {
                this.showTag = true;
                this.tagText = this.getLabel('allSelectedMessage');
                this._placeholder = "";
                this.showDeleteIcon = true;
                this.showDriverLine = true;
                this.selectAllItem.checked = true;
            }
            else if (s === 0) {
                this.showTag = false;
                this.showDriverLine = false;
                this.showDeleteIcon = false;
                this.selectAllItem.checked = false;
                this._placeholder = this.customPlaceholder;
            }
            else if (s > 1 &&
                s < originalL &&
                availCheckedLen === s &&
                availAllChecked === -1) {
                this.showTag = true;
                this.showDeleteIcon = true;
                this.showDriverLine = true;
                this._placeholder = "";
                this.tagText = this.getSelectionMessage(s);
                this.selectAllItem.checked = true;
            }
        }
    }
    onKeydown(event) {
        let keyCode = event.keyCode;
        switch (keyCode) {
            case 27: //esc
                if (this.showList) {
                    this.hide(event);
                }
                this.removeKeyboard();
                this.updateIcon();
                if (this.inputViewChild)
                    this.inputViewChild.nativeElement.focus();
                event.preventDefault();
                event.stopPropagation();
                break;
            case 13: //enter
                // case 32: //sapce
                if (this.selectType === "single") {
                    if (!this.showList) {
                        if ((this.normalTempItem && Object.keys(this.normalTempItem).length === 0 || !this.normalTempItem) &&
                            !this.grouped) {
                            this.normalTempItem =
                                this.dropdownService.setSingleFocusedItem(0, this.list);
                        }
                        this.show();
                        this.updateIcon();
                        // this.commonNullFilter(event);
                        this.keywordFilter(event);
                        if (this.grouped) {
                            if (Object.keys(this.groupedTempItem).length === 0) {
                                this.setMultipleDefaultFocusedItem(0);
                                this.setNextMoved();
                            }
                            else {
                                this.dropdownService.groupedDataUpdateStatus(this.list, this.optionValue, this.groupedTempItem);
                            }
                        }
                        else {
                            this.dropdownService.normalDataUpdateStatus(this.list, this.optionValue, this.normalTempItem);
                        }
                    }
                    else {
                        let selectTemp = this.comboboxListItemArray
                            ?.toArray()
                            .find((o) => o.item.focused === true);
                        if (selectTemp) {
                            selectTemp.onSelectItem.next({
                                originEvent: event,
                                selected: this.grouped
                                    ? this.groupedTempItem
                                    : this.normalTempItem,
                                eventType: "keydown",
                            });
                        }
                    }
                }
                if (this.selectType === "multiple") {
                    if (!this.showList) {
                        if (this.grouped) {
                            if (Object.keys(this.groupedTempItem).length === 0) {
                                if (this.showSelectAll) {
                                    this.selectAllItem.focused = true;
                                    this.groupedTempItem = this.selectAllItem;
                                }
                                else {
                                    this.setMultipleDefaultFocusedItem(0);
                                    this.setNextMoved();
                                }
                            }
                            else {
                                if (this.showSelectAll &&
                                    this.groupedTempItem.value === "selectAll") {
                                    this.selectAllItem.focused = true;
                                    this.groupedTempItem = this.selectAllItem;
                                }
                            }
                        }
                        else {
                            if ((this.normalTempItem && Object.keys(this.normalTempItem).length === 0) || !this.normalTempItem) {
                                if (this.showSelectAll) {
                                    this.selectAllItem.focused = true;
                                    this.normalTempItem = this.selectAllItem;
                                }
                                else {
                                    this.normalTempItem =
                                        this.dropdownService.setSingleFocusedItem(0, this.list);
                                }
                            }
                            else {
                                if (this.showSelectAll &&
                                    this.normalTempItem[this.optionName] === this.selectAllItem[this.optionName]) {
                                    this.selectAllItem.focused = true;
                                    this.normalTempItem = this.selectAllItem;
                                }
                            }
                        }
                        this.show();
                        // this.whetherClearKeyword();
                        this.updateIcon();
                        // this.commonNullFilter(event);
                        this.keywordFilter(event);
                        this.setNextMoved();
                        this.setComboboxFieldValue();
                    }
                    else {
                        if (this.selectAllItem.focused) {
                            event.selected = this.selectAllItem;
                            this.onClickSelectAll(event);
                        }
                        else {
                            let selectTemp = this.comboboxListItemArray
                                ?.toArray()
                                .find((o) => o.item.focused === true);
                            if (this.grouped) {
                                if (selectTemp) {
                                    if (selectTemp.item.checked) {
                                        this.groupedTempItem = selectTemp.item;
                                    }
                                    selectTemp.onSelectItem.next({
                                        originEvent: event,
                                        selected: this.groupedTempItem,
                                        eventType: "keydown",
                                    });
                                }
                            }
                            else {
                                if (selectTemp) {
                                    if (selectTemp.item.checked) {
                                        this.normalTempItem = selectTemp.item;
                                    }
                                    selectTemp.onSelectItem.next({
                                        originEvent: event,
                                        selected: this.normalTempItem,
                                        eventType: "keydown",
                                    });
                                }
                            }
                        }
                    }
                }
                event.preventDefault();
                break;
            case 40: //down
                if (!this.showList)
                    this.show();
                if ((this.grouped && this.resultList?.length > 0 && this.resultList[0].items?.every(item => item.disabled === true))
                    || (!this.grouped && this.resultList?.every(item => item.disabled === true))) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                if (this.selectType === "single" && this.list?.length) {
                    if (this.grouped) {
                        this.groupedTempItem =
                            this.dropdownService.groupedMultipleDownNext(this.list, this.optionName, this.optionValue, this.groupedTempItem, this.showSelectAll, this.selectAllItem);
                    }
                    else {
                        this.normalTempItem =
                            this.dropdownService.singleDownNext(this.list, this.optionValue, this.normalTempItem);
                        this.dropdownService.normalDataUpdateStatus(this.list, this.optionValue, this.normalTempItem);
                    }
                }
                if (this.selectType === "multiple" && this.list?.length) {
                    if (this.grouped) {
                        this.groupedTempItem =
                            this.dropdownService.groupedMultipleDownNext(this.list, this.optionName, this.optionValue, this.groupedTempItem, this.showSelectAll, this.selectAllItem);
                    }
                    else {
                        this.normalTempItem =
                            this.dropdownService.singleDownNext(this.list, this.optionValue, this.normalTempItem, this.showSelectAll, this.selectAllItem);
                        this.dropdownService.normalDataUpdateStatus(this.list, this.optionValue, this.normalTempItem);
                    }
                }
                this.setNextMoved();
                if (this.grouped) {
                    this.groupDataScroll();
                }
                else {
                    this.normalDataScroll();
                }
                event.preventDefault();
                event.stopPropagation();
                break;
            case 38: //up
                if ((this.grouped && this.resultList?.length > 0 && this.resultList[0].items?.every(item => item.disabled === true))
                    || (!this.grouped && this.resultList?.every(item => item.disabled === true))) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                if (this.selectType === "single" && this.list?.length) {
                    if (this.grouped) {
                        this.groupedTempItem =
                            this.dropdownService.groupedMultipleUpNext(this.list, this.optionName, this.optionValue, this.groupedTempItem, this.showSelectAll, this.selectAllItem);
                    }
                    else {
                        this.normalTempItem = this.dropdownService.singleUpNext(this.list, this.optionValue, this.normalTempItem);
                    }
                }
                if (this.selectType === "multiple" && this.list?.length) {
                    if (this.grouped) {
                        if (this.groupedTempItem[this.optionName] ===
                            this.selectAllItem[this.optionName] &&
                            this.selectAllItem.focused) {
                            this.selectAllItem.focused = false;
                        }
                        this.groupedTempItem =
                            this.dropdownService.groupedMultipleUpNext(this.list, this.optionName, this.optionValue, this.groupedTempItem, this.showSelectAll, this.selectAllItem);
                    }
                    else {
                        this.normalTempItem = this.dropdownService.singleUpNext(this.list, this.optionValue, this.normalTempItem, this.showSelectAll, this.selectAllItem);
                    }
                }
                this.setNextMoved();
                if (this.grouped) {
                    this.groupDataScroll();
                }
                else {
                    this.normalDataScroll();
                }
                event.preventDefault();
                event.stopPropagation();
                break;
            case 9: //tab
                if (!event?.shiftKey &&
                    this.showDeleteIcon &&
                    this.focusInput &&
                    this.showList) {
                    return;
                }
                const focusableElement = !event?.shiftKey ? this.getFocusableElement(this.el.nativeElement, document.activeElement) :
                    this.getFocusableElement(this.el.nativeElement, document.activeElement, false);
                if (this.showList && (!this.el.nativeElement?.contains(focusableElement) ||
                    (focusableElement === this.secondaryDelIcon?.nativeElement && !this.showDeleteIcon))) {
                    this.hide(event, true);
                }
                break;
        }
    }
    removeKeyboard() {
        if (this.selectType === "single") {
            if (this.grouped) {
                // this.groupedDataRemoveKeyboard();
                this.dropdownService.groupedDataRemoveKeyboard(this.list);
                if (this.selectAllItem.focused) {
                    this.selectAllItem.focused = false;
                }
            }
            else {
                // this.normalDataRemoveKeyboard();
                this.dropdownService.normalDataRemoveKeyboard(this.list);
                if (this.selectAllItem.focused) {
                    this.selectAllItem.focused = false;
                }
            }
        }
        else if (this.selectType === "multiple") {
            if (this.grouped) {
                // this.groupedDataRemoveKeyboard();
                this.dropdownService.groupedDataRemoveKeyboard(this.list);
                if (this.selectAllItem.focused) {
                    this.selectAllItem.focused = false;
                }
            }
            else {
                // this.normalDataRemoveKeyboard();
                this.dropdownService.normalDataRemoveKeyboard(this.list);
                if (this.selectAllItem.focused) {
                    this.selectAllItem.focused = false;
                }
            }
        }
    }
    onOutsideKeydown(event) {
        let keyCode = event.keyCode;
        if (keyCode === 27) {
            this.onKeydown(event);
        }
    }
    setNextMoved(type) {
        if (this.selectType === "multiple") {
            if (this.grouped) {
                this.dropdownService.groupedDataUpdateStatus(this.list, this.optionValue, this.groupedTempItem);
            }
            else {
                this.dropdownService.normalDataUpdateStatus(this.list, this.optionValue, this.normalTempItem);
            }
        }
        else if (this.selectType === "single") {
            if (this.grouped) {
                this.dropdownService.groupedDataUpdateStatus(this.list, this.optionValue, this.groupedTempItem);
            }
            else {
                this.dropdownService.normalDataUpdateStatus(this.list, this.optionValue, this.normalTempItem);
            }
        }
        if (type === 'click') {
            this.getActiveItemIdByActiveClass();
        }
        else {
            this.getActiveItemId();
        }
        // if (this.selectType === "multiple") {
        //     if (this.grouped) {
        //         this.groupDataScroll();
        //         // this.dropdownService.groupDataScroll(this.currentActiveEle, this.listboxEl);
        //     } else {
        //         this.normalDataScroll();
        //     }
        // } else if (this.selectType === "single") {
        //     if (this.grouped) {
        //         this.groupDataScroll();
        //         // this.dropdownService.groupDataScroll(this.currentActiveEle, this.listboxEl);
        //     } else {
        //         this.normalDataScroll();
        //     }
        // }
    }
    getActiveItemId() {
        setTimeout(() => {
            // this.itemNodeList = this.el.nativeElement.querySelectorAll(".ap-option-item");
            this.currentActiveEle = this.el.nativeElement.querySelector("#" + this.listId + " .ap-option-item.moved");
            this.itemNodeList.forEach((item) => {
                if (item === this.currentActiveEle) {
                    this.activeId = item.id;
                }
            });
        });
    }
    getActiveItemIdByActiveClass() {
        setTimeout(() => {
            // this.itemNodeList = this.el.nativeElement.querySelectorAll(".ap-option-item");
            this.currentActiveEle = this.el.nativeElement.querySelector("#" + this.listId + " .ap-option-item.active");
            this.itemNodeList.forEach((item) => {
                if (item === this.currentActiveEle) {
                    this.activeId = item.id;
                }
            });
        });
    }
    setInitialOptionNameAndValue() {
        if (!this.optionName &&
            this.comboboxListItemArray?.last &&
            this.comboboxListItemArray?.last.optionName !== undefined) {
            this.optionName = this.comboboxListItemArray?.last.optionName;
        }
        if (!this.optionValue &&
            this.comboboxListItemArray?.last &&
            this.comboboxListItemArray?.last.optionValue !== undefined) {
            this.optionValue = this.comboboxListItemArray?.last.optionValue;
        }
    }
    ngAfterViewInit() {
        this.setInitialOptionNameAndValue();
        this.listboxEl = this.el.nativeElement.querySelector("#" + this.listId);
        this.itemNodeList = this.el.nativeElement.querySelectorAll("#" + this.listId + " .ap-option-item");
        this.keydownObservable$ = fromEvent(window, "keydown");
        this.keydownSubscription$ = this.keydownObservable$.subscribe((event) => {
            const keycode = window.event ? event.keyCode : event.which;
            if (keycode === 9) {
                this.render.addClass(this.el.nativeElement.querySelector(".ap-combobox-input-box"), "keyboard-focus");
                this.render.addClass(this.el.nativeElement.querySelector(".ap-combobox"), "keyboard-focus");
            }
            // if(keycode === 27 && this.attachedDOM) {
            // this.onKeydown(event);
            // }
        });
        this.clickObservable$ = fromEvent(window, "click");
        this.clickSubscription$ = this.clickObservable$.subscribe((event) => {
            this.render.removeClass(this.el.nativeElement.querySelector(".ap-combobox-input-box"), "keyboard-focus");
            this.render.removeClass(this.el.nativeElement.querySelector(".ap-combobox"), "keyboard-focus");
        });
        this.setInputMaxWidth();
    }
    setInputMaxWidth() {
        if (this.showMultipleTags) {
            const maxWidth = this.el.nativeElement.getBoundingClientRect().width - (this.finalItems.length > 0 ? 112 : 56);
            this.inputViewChild && this.render.setStyle(this.inputViewChild.nativeElement, 'max-width', convertToRem(maxWidth));
        }
    }
    groupDataScroll() {
        setTimeout(() => {
            let groupedTempEle = this.currentActiveEle;
            if (groupedTempEle &&
                this.dropdownService.isScrollable(this.listboxEl)) {
                this.dropdownService.maintainScrollVisibility(groupedTempEle, this.listboxEl, this.grouped);
            }
            if (groupedTempEle &&
                !this.dropdownService.isElementInView(groupedTempEle)) {
                groupedTempEle.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }
        }, 0);
    }
    normalDataScroll() {
        setTimeout(() => {
            let normalTempEle = this.currentActiveEle;
            if (normalTempEle &&
                this.dropdownService.isScrollable(this.listboxEl)) {
                this.dropdownService.maintainScrollVisibility(normalTempEle, this.listboxEl, this.grouped);
            }
            if (normalTempEle &&
                !this.dropdownService.isElementInView(normalTempEle)) {
                normalTempEle.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }
        }, 0);
    }
    setMultipleDefaultFocusedItem(groupIndex) {
        if (this.list[groupIndex].type === "group") {
            let subItems = this.list[groupIndex].items;
            if (subItems && subItems.length > 0) {
                this.getSubFocusItem(0, subItems, groupIndex);
            }
        }
    }
    getSubFocusItem(index, subItems, groupIndex) {
        let subDisabledStatus = subItems[index].disabled;
        if (!subDisabledStatus) {
            this.groupedTempItem = subItems[index];
        }
        else {
            index = index + 1;
            if (index < subItems.length) {
                this.getSubFocusItem(index, subItems, groupIndex);
            }
            else {
                groupIndex = groupIndex + 1;
                this.setMultipleDefaultFocusedItem(groupIndex);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComboboxComponent, deps: [{ token: i1.DropdownService }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i2.LocalizationConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ComboboxComponent, selector: "ap-combobox", inputs: { readonly: "readonly", disabled: "disabled", required: "required", error: "error", styleClass: "styleClass", style: "style", selectType: "selectType", placeholder: "placeholder", optionName: "optionName", optionValue: "optionValue", list: "list", listId: "listId", comboboxId: "comboboxId", showDeleteIcon: "showDeleteIcon", showSelectAll: "showSelectAll", noResultMsg: "noResultMsg", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", resultStatus: "resultStatus", showMultipleTags: "showMultipleTags", maxHeight: "maxHeight", showLoading: "showLoading", showAllSelectedTag: "showAllSelectedTag" }, outputs: { onClose: "onClose", onSelect: "onSelect", onFilterResult: "onFilterResult" }, providers: [COMBOBOX_VALUE_ACCESSOR], queries: [{ propertyName: "comboboxListItemArray", predicate: DropdownListItemComponent }], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["comboboxInput"], descendants: true }, { propertyName: "iconChevron", first: true, predicate: ["iconChevron"], descendants: true }, { propertyName: "comboboxList", first: true, predicate: ["comboboxList"], descendants: true }, { propertyName: "inputBoxItems", first: true, predicate: ["inputBoxItems"], descendants: true }, { propertyName: "inputArea", first: true, predicate: ["inputArea"], descendants: true }, { propertyName: "secondaryDelIcon", first: true, predicate: ["secondaryDelIcon"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"ap-combobox {{styleClass}}\" [style]=\"style\"\n    (keydown)=\"onOutsideKeydown($event)\" [class.disabled]=\"disabled\" [class.readonly]=\"readonly\" [class.error]=\"error\"\n    [attr.id]=\"comboboxId\">\n    <div class=\"search-result\" aria-live=\"assertive\" aria-atomic=\"true\">{{ resultStatus }}</div>\n    <div class=\"ap-combobox-input-box\" id=\"comboboxInputArea\" [class.showOverflow]=\"showMultipleTags\"\n        [attr.aria-haspopup]=\"true\" [attr.aria-live]=\"'polite'\"\n        [attr.aria-labelledby]=\"ariaLabelledBy\" (keydown)=\"onKeydown($event)\"\n        (click)=\"!disabled && !readonly && onToggle($event)\" #inputArea>\n        <div *ngIf=\"showTag||showMultipleTags\" class=\"ap-combobox-input-box-container\" [class.no-items]=\"finalItems.length===0\"\n            [ngStyle]=\"comboboxContainerStyle\">\n            <ap-tag *ngIf=\"!showMultipleTags||(selectAllItem?.checked&&finalItems.length>0&&showAllSelectedTag)\" [text]=\"tagText\"\n                [disabled]=\"disabled || readonly\" [tabindex]=\"-1\" [showClose]=\"false\"\n                [styleClass]=\"'combobox-tag'\"></ap-tag>\n            <div *ngIf=\"showMultipleTags&&selectAllItem?.checked&&finalItems.length>0&&showAllSelectedTag\"\n                [ngTemplateOutlet]=\"inputTemplate\"></div>\n            <ng-container *ngIf=\"showMultipleTags&&(!selectAllItem?.checked||!showAllSelectedTag)\">\n                <div class=\"ap-combobox-input-box-items\" #inputBoxItems>\n                    <div class=\"combobox-tag-wrapper\" *ngFor=\"let item of finalItems;let i=index\">\n                        <ap-tag [text]=\"item[optionName]\"\n                            [disabled]=\"disabled || readonly\" [styleClass]=\"'combobox-tag combobox-tag-item'\"\n                            (onClose)=\"closeTag($event, item)\"></ap-tag>\n                    </div>\n                    <div [ngTemplateOutlet]=\"inputTemplate\"\n                        [ngTemplateOutletContext]=\"{isChangeWidth: finalItems.length > 0? true : false}\"></div>\n                </div>\n            </ng-container>\n        </div>\n        <div *ngIf=\"!showMultipleTags\" [ngTemplateOutlet]=\"inputTemplate\"></div>\n        <ng-template #inputTemplate let-isChangeWidth=\"isChangeWidth\">\n            <input #comboboxInput role=\"combobox\" type=\"text\" [attr.aria-expanded]=\"showList\" class=\"ap-combobox-input\" [attr.id]=\"comboboxInputId\"\n                [class.select-all]=\"selectAllItem?.checked&&finalItems.length>0\"\n                [class.input-width]=\"finalItems.length > 0\" [attr.aria-disabled]=\"disabled\"\n                [attr.aria-readonly]=\"readonly\" [disabled]=\"disabled\" [attr.aria-owns]=\"listId\"\n                [attr.aria-controls]=\"listId\" [attr.aria-autocomplete]=\"'list'\" [attr.tabindex]=\"disabled||readonly ? '-1' : '0'\"\n                [attr.aria-label]=\"ariaLabel\" [required]=\"required\" [class.exceedPadding]=\"showDeleteIcon\"\n                (input)=\"onInputChange($event, isChangeWidth)\" (focus)=\"focusInput=true\" (blur)=\"focusInput=false\" [ngStyle]=\"inputStyle\" />\n                <label *ngIf=\"!hidePlaceholder\" [attr.for]=\"comboboxInputId\" class=\"ap-combobox-placeholder\">{{_placeholder}}</label>\n        </ng-template>\n        <span #secondaryDelIcon class=\"ap-combobox-clear-icon\" [class.showDeleteIcon]=\"showDeleteIcon\"\n            [attr.aria-label]=\"getLabel('clear')\" (click)=\"onClickDeleteIncon($event)\"\n            [attr.tabindex]=\"disabled||readonly ? '-1' : '0'\" (keydown)=\"onKeydownDeleteIcon($event)\">\n            <span class=\"Appkit4-icon icon-circle-delete-outline\"\n                [attr.aria-disabled]=\"disabled\" [attr.aria-readonly]=\"readonly\"\n                [class.error]=\"error\"></span>\n        </span>\n        <span *ngIf=\"showDriverLine\" class=\"separte-line\"></span>\n        <span class=\"ap-combobox-toggle-box\" [attr.role]=\"'button'\" [attr.aria-label]=\"getAriaLabel('toggleButtonLabel')\"\n        [attr.tabindex]=\"-1\">\n            <span [id]=\"iconId\" class=\"Appkit4-icon icon-down-chevron-outline\" [attr.alt]=\"getAriaLabel('toggleButtonLabel')\"\n                [attr.aria-hidden]=\"true\" [class.readonly]=\"readonly\" [class.disabled]=\"disabled\"\n                #iconChevron>\n            </span>\n        </span>\n    </div>\n    <div class=\"ap-combobox-dropdown-list\" [attr.role]=\"'listbox'\" [class.open]=\"showList\"\n        [attr.aria-labelledby]=\"'combo1-label'\" [class.hide]=\"!showList\" [attr.id]=\"listId\" #comboboxList>\n        <ng-template [ngTemplateOutlet]=\"comboboxlistTemp\"></ng-template>\n    </div>\n</div>\n<ng-template #comboboxlistTemp>\n    <ng-container *ngIf=\"showSelectAll && selectType === 'multiple' && list.length > 0 \">\n        <ap-dropdown-list-item #dropdownListItem [item]=\"selectAllItem\" [ariaLabel]=\"getLabel('selectAll')\" [role]=\"'checkbox'\"\n            [styleClass]=\"'selectAll'\" [highlightText]=\"searchText\" [showCheckbox]=\"selectAllItem.showCheckbox\"\n            (onSelectItem)=\"onClickSelectAll($event)\">\n        </ap-dropdown-list-item>\n    </ng-container>\n    <ng-content></ng-content>\n    <ng-container *ngIf=\"showBlankPage\">\n        <div class=\"ap-option-item noResult\">\n            <span class=\"ap-option-label \">{{ _noResultMsg }}</span>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"showLoading\">\n        <div class=\"loading-container\">\n            <ap-loading [loadingType]=\"'circular'\" [indeterminate]=\"true\" [compact]=\"false\"></ap-loading>\n        </div>\n    </ng-container>\n</ng-template>", styles: ["::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper{max-width:100%}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3);background-color:var(--color-background-hover-selected);color:var(--color-text-body);width:max-content;max-width:100%}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{background-color:var(--color-background-primary);color:var(--color-text-secondary)}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item .ap-tag-label{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag .ap-tag-label{font-weight:400}::ng-deep .ap-combobox .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3);background-color:var(--color-background-hover-selected);color:var(--color-text-body);width:max-content}::ng-deep .ap-combobox .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag .ap-tag-label{font-weight:400}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{margin-left:var(--spacing-2)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag:not(.combobox-tag-item){transform:translateY(-.0625rem)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow.overflow-line .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{margin-bottom:0}::ng-deep .ap-combobox.disabled .ap-combobox-input-box .ap-tag.ap-tag-default.combobox-tag.combobox-tag-item{background-color:var(--color-background-hover-selected);color:var(--color-text-body)}::ng-deep .ap-combobox.error .ap-combobox-input-box .ap-tag.ap-tag-default.combobox-tag.combobox-tag-item{background-color:var(--color-background-danger);color:var(--color-text-secondary)}.ap-combobox{position:relative}.ap-combobox .ap-combobox-input-box{position:relative;display:flex;width:100%;height:3rem;background-color:var(--color-background-container);border-radius:var(--border-radius-2);box-shadow:inset 0 0 0 .0625rem var(--color-background-border);overflow:hidden;box-sizing:border-box;align-items:center}.ap-combobox .ap-combobox-input-box.showOverflow{flex-wrap:wrap;width:unset;min-height:3rem;line-height:3rem;height:unset!important;justify-content:unset}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container{width:calc(100% - 6rem);display:flex;overflow-y:auto}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container.no-items,.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container.no-items .ap-combobox-input-box-items{width:100%}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container .ap-combobox-input-box-items{display:flex;flex-wrap:wrap;padding-left:var(--spacing-2);align-items:flex-end}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container::-webkit-scrollbar{display:none}.ap-combobox .ap-combobox-input-box .ap-combobox-input{width:100%;padding:var(--spacing-4) var(--spacing-8) var(--spacing-4) var(--spacing-3);height:3rem;color:var(--color-text-body);font-size:1rem;letter-spacing:-.025rem;line-height:1.5rem;background-color:transparent;outline:0!important;position:absolute}.ap-combobox .ap-combobox-input-box .ap-combobox-input.input-width{position:unset}.ap-combobox .ap-combobox-input-box .ap-combobox-input.exceedPadding{padding-right:6rem}.ap-combobox .ap-combobox-input-box .ap-combobox-input+label{position:absolute;left:var(--spacing-3);top:var(--spacing-4);color:var(--color-text-light);font-size:1rem;line-height:1.5rem;letter-spacing:-.025rem}.ap-combobox .ap-combobox-input-box .ap-combobox-input[required]+label:after{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;background-color:var(--color-text-error);border-radius:50%}.ap-combobox .ap-combobox-input-box.overflow-line{line-height:1.75rem}.ap-combobox .ap-combobox-input-box.overflow-line .ap-combobox-input{height:1.75rem;line-height:1.75rem}.ap-combobox .ap-combobox-input-box.overflow-line .ap-combobox-input-box-items{padding-top:var(--spacing-3);padding-bottom:var(--spacing-4)}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-clear-icon{top:unset!important}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input{position:inherit;padding:0;margin-left:var(--spacing-2);display:block}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.input-width{width:.25rem}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.select-all{width:inherit}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.exceedPadding{padding-right:0}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon{position:absolute;top:var(--spacing-2);right:3.3125rem;border-radius:var(--border-radius-2);visibility:hidden;display:flex;justify-content:center}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline{width:2.5rem;height:2.5rem;line-height:2.5rem;cursor:pointer;color:var(--color-text-body)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline.disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline.readonly{cursor:not-allowed}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline:not(.disabled):not(.error):hover{cursor:pointer;border-radius:var(--border-radius-2);background-color:var(--color-background-hover-selected)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon.showDeleteIcon{visibility:visible}.ap-combobox .ap-combobox-input-box .separte-line{position:absolute;display:inline-block;top:var(--spacing-3);right:2.875rem;width:.0625rem;height:calc(100% - 1rem);border-radius:.03125rem;background-color:#d1d1d1}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline{position:absolute;right:var(--spacing-2);top:0;width:2.5rem;height:100%;line-height:100%;border-radius:var(--border-radius-1);transform:rotate(0);transition:transform .3s;color:var(--color-text-body)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.up{transform:rotate(-180deg)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.readonly{cursor:not-allowed}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline:not(.disabled):hover{cursor:pointer}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-input::placeholder{color:rgba(var(--color-text-light-rgb),var(--opacity-5))}.ap-combobox .ap-combobox-dropdown-list{z-index:99;position:absolute;display:block;width:100%;top:3.5rem;left:0;padding:var(--spacing-3);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container);color:var(--color-text-body);transform:translateY(.75rem);visibility:hidden;opacity:0;max-height:17.5rem;overflow:auto}.ap-combobox .ap-combobox-dropdown-list.open{visibility:visible;opacity:1;transform:translateY(0);transition:visibility .3s,opacity .3s,transform .3s;pointer-events:auto}.ap-combobox .ap-combobox-dropdown-list.hide{visibility:hidden;animation-fill-mode:both;transition:all .3s ease-in-out}.ap-combobox .ap-combobox-dropdown-list .ap-option-item{position:relative;width:100%;height:3rem;margin-bottom:var(--spacing-2);padding:var(--spacing-4) var(--spacing-3);border-radius:var(--border-radius-2);cursor:pointer;display:flex;justify-content:space-between;align-items:center;line-height:1.5rem;color:var(--color-text-body)}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult{justify-content:center;margin-bottom:0!important}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult:hover{cursor:auto;background-color:var(--color-background-container)}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult .ap-option-label{padding-right:0}.ap-combobox.disabled{cursor:not-allowed}.ap-combobox.disabled .ap-combobox-input-box{cursor:not-allowed;pointer-events:none;box-shadow:inset 0 0 0 .0625rem rgba(var(--color-background-border-rgb),var(--opacity-6))}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-input{cursor:not-allowed;color:rgba(var(--color-text-heading-rgb),var(--opacity-5))}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline{color:rgba(var(--color-text-light-rgb),var(--opacity-5))}.ap-combobox.disabled .ap-combobox-input-box .separte-line{opacity:var(--opacity-5)}.ap-combobox.readonly{cursor:not-allowed}.ap-combobox.readonly .ap-combobox-input-box{pointer-events:none;cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-background-border)}.ap-combobox.readonly .ap-combobox-input-box .ap-combobox-input{pointer-events:none;color:var(--color-text-heading);opacity:var(--opacity-6)}.ap-combobox.readonly .ap-combobox-input-box .ap-combobox-clear-icon,.ap-combobox.readonly .ap-combobox-input-box .icon-down-chevron-outline{opacity:var(--opacity-6);pointer-events:none}.ap-combobox.error .ap-combobox-input-box{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3));box-shadow:inset 0 0 0 .0625rem var(--color-background-danger)}.ap-combobox.error .ap-combobox-input-box:focus-within:not(.keyboard-focus){box-shadow:0 0 0 .0625rem var(--color-background-danger),0 0 0 .25rem rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}.ap-combobox.error .ap-combobox-input-box .ap-combobox-input{color:var(--color-text-body)}.ap-combobox.error .ap-combobox-input-box .ap-combobox-clear-icon:hover{border-radius:var(--spacing-2);background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}.ap-combobox:not(.disabled):not(.readonly) .ap-combobox-input-box:focus-within:not(.keyboard-focus){box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}.ap-combobox:not(.disabled):not(.readonly) .ap-combobox-input-box:focus-within.keyboard-focus{outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}.ap-combobox:not(.disabled):not(.readonly):not(.error) .ap-combobox-input-box:hover{background-color:var(--color-background-hover)}.ap-combobox .search-result{border:0;clip:rect(0px,0px,0px,0px);height:.0625rem;margin-bottom:-.0625rem;margin-right:-.0625rem;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:.0625rem}.ap-combobox .loading-container{display:flex;justify-content:center;align-items:center;height:4rem;width:100%}::ng-deep .ap-combobox.error .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{background-color:var(--color-background-danger);color:var(--color-text-tertiary)}\n"], dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i4.TagComponent, selector: "ap-tag", inputs: ["type", "size", "text", "tabindex", "inputId", "disabled", "showClose", "styleClass", "style", "backgroundColor", "fontColor", "ariaLabel"], outputs: ["onClose"] }, { kind: "component", type: i5.DropdownListItemComponent, selector: "ap-dropdown-list-item", inputs: ["highlightText", "selectType", "style", "styleClass", "role", "item", "tabindex", "optionName", "optionValue", "inputId", "showCheckbox", "showTag", "ariaLabel", "addAriaCurrent", "descValue", "showTooltip"], outputs: ["onSelectItem", "onUpdateItem", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave"] }, { kind: "component", type: i6.LoadingComponent, selector: "ap-loading", inputs: ["loadingType", "indeterminate", "compact", "styleClass", "style", "linearWidth", "loadingId", "stopPercent", "circularWidth"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComboboxComponent, decorators: [{
            type: Component,
            args: [{ selector: "ap-combobox", providers: [COMBOBOX_VALUE_ACCESSOR], template: "<div class=\"ap-combobox {{styleClass}}\" [style]=\"style\"\n    (keydown)=\"onOutsideKeydown($event)\" [class.disabled]=\"disabled\" [class.readonly]=\"readonly\" [class.error]=\"error\"\n    [attr.id]=\"comboboxId\">\n    <div class=\"search-result\" aria-live=\"assertive\" aria-atomic=\"true\">{{ resultStatus }}</div>\n    <div class=\"ap-combobox-input-box\" id=\"comboboxInputArea\" [class.showOverflow]=\"showMultipleTags\"\n        [attr.aria-haspopup]=\"true\" [attr.aria-live]=\"'polite'\"\n        [attr.aria-labelledby]=\"ariaLabelledBy\" (keydown)=\"onKeydown($event)\"\n        (click)=\"!disabled && !readonly && onToggle($event)\" #inputArea>\n        <div *ngIf=\"showTag||showMultipleTags\" class=\"ap-combobox-input-box-container\" [class.no-items]=\"finalItems.length===0\"\n            [ngStyle]=\"comboboxContainerStyle\">\n            <ap-tag *ngIf=\"!showMultipleTags||(selectAllItem?.checked&&finalItems.length>0&&showAllSelectedTag)\" [text]=\"tagText\"\n                [disabled]=\"disabled || readonly\" [tabindex]=\"-1\" [showClose]=\"false\"\n                [styleClass]=\"'combobox-tag'\"></ap-tag>\n            <div *ngIf=\"showMultipleTags&&selectAllItem?.checked&&finalItems.length>0&&showAllSelectedTag\"\n                [ngTemplateOutlet]=\"inputTemplate\"></div>\n            <ng-container *ngIf=\"showMultipleTags&&(!selectAllItem?.checked||!showAllSelectedTag)\">\n                <div class=\"ap-combobox-input-box-items\" #inputBoxItems>\n                    <div class=\"combobox-tag-wrapper\" *ngFor=\"let item of finalItems;let i=index\">\n                        <ap-tag [text]=\"item[optionName]\"\n                            [disabled]=\"disabled || readonly\" [styleClass]=\"'combobox-tag combobox-tag-item'\"\n                            (onClose)=\"closeTag($event, item)\"></ap-tag>\n                    </div>\n                    <div [ngTemplateOutlet]=\"inputTemplate\"\n                        [ngTemplateOutletContext]=\"{isChangeWidth: finalItems.length > 0? true : false}\"></div>\n                </div>\n            </ng-container>\n        </div>\n        <div *ngIf=\"!showMultipleTags\" [ngTemplateOutlet]=\"inputTemplate\"></div>\n        <ng-template #inputTemplate let-isChangeWidth=\"isChangeWidth\">\n            <input #comboboxInput role=\"combobox\" type=\"text\" [attr.aria-expanded]=\"showList\" class=\"ap-combobox-input\" [attr.id]=\"comboboxInputId\"\n                [class.select-all]=\"selectAllItem?.checked&&finalItems.length>0\"\n                [class.input-width]=\"finalItems.length > 0\" [attr.aria-disabled]=\"disabled\"\n                [attr.aria-readonly]=\"readonly\" [disabled]=\"disabled\" [attr.aria-owns]=\"listId\"\n                [attr.aria-controls]=\"listId\" [attr.aria-autocomplete]=\"'list'\" [attr.tabindex]=\"disabled||readonly ? '-1' : '0'\"\n                [attr.aria-label]=\"ariaLabel\" [required]=\"required\" [class.exceedPadding]=\"showDeleteIcon\"\n                (input)=\"onInputChange($event, isChangeWidth)\" (focus)=\"focusInput=true\" (blur)=\"focusInput=false\" [ngStyle]=\"inputStyle\" />\n                <label *ngIf=\"!hidePlaceholder\" [attr.for]=\"comboboxInputId\" class=\"ap-combobox-placeholder\">{{_placeholder}}</label>\n        </ng-template>\n        <span #secondaryDelIcon class=\"ap-combobox-clear-icon\" [class.showDeleteIcon]=\"showDeleteIcon\"\n            [attr.aria-label]=\"getLabel('clear')\" (click)=\"onClickDeleteIncon($event)\"\n            [attr.tabindex]=\"disabled||readonly ? '-1' : '0'\" (keydown)=\"onKeydownDeleteIcon($event)\">\n            <span class=\"Appkit4-icon icon-circle-delete-outline\"\n                [attr.aria-disabled]=\"disabled\" [attr.aria-readonly]=\"readonly\"\n                [class.error]=\"error\"></span>\n        </span>\n        <span *ngIf=\"showDriverLine\" class=\"separte-line\"></span>\n        <span class=\"ap-combobox-toggle-box\" [attr.role]=\"'button'\" [attr.aria-label]=\"getAriaLabel('toggleButtonLabel')\"\n        [attr.tabindex]=\"-1\">\n            <span [id]=\"iconId\" class=\"Appkit4-icon icon-down-chevron-outline\" [attr.alt]=\"getAriaLabel('toggleButtonLabel')\"\n                [attr.aria-hidden]=\"true\" [class.readonly]=\"readonly\" [class.disabled]=\"disabled\"\n                #iconChevron>\n            </span>\n        </span>\n    </div>\n    <div class=\"ap-combobox-dropdown-list\" [attr.role]=\"'listbox'\" [class.open]=\"showList\"\n        [attr.aria-labelledby]=\"'combo1-label'\" [class.hide]=\"!showList\" [attr.id]=\"listId\" #comboboxList>\n        <ng-template [ngTemplateOutlet]=\"comboboxlistTemp\"></ng-template>\n    </div>\n</div>\n<ng-template #comboboxlistTemp>\n    <ng-container *ngIf=\"showSelectAll && selectType === 'multiple' && list.length > 0 \">\n        <ap-dropdown-list-item #dropdownListItem [item]=\"selectAllItem\" [ariaLabel]=\"getLabel('selectAll')\" [role]=\"'checkbox'\"\n            [styleClass]=\"'selectAll'\" [highlightText]=\"searchText\" [showCheckbox]=\"selectAllItem.showCheckbox\"\n            (onSelectItem)=\"onClickSelectAll($event)\">\n        </ap-dropdown-list-item>\n    </ng-container>\n    <ng-content></ng-content>\n    <ng-container *ngIf=\"showBlankPage\">\n        <div class=\"ap-option-item noResult\">\n            <span class=\"ap-option-label \">{{ _noResultMsg }}</span>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"showLoading\">\n        <div class=\"loading-container\">\n            <ap-loading [loadingType]=\"'circular'\" [indeterminate]=\"true\" [compact]=\"false\"></ap-loading>\n        </div>\n    </ng-container>\n</ng-template>", styles: ["::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper{max-width:100%}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3);background-color:var(--color-background-hover-selected);color:var(--color-text-body);width:max-content;max-width:100%}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{background-color:var(--color-background-primary);color:var(--color-text-secondary)}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item .ap-tag-label{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}::ng-deep .ap-combobox .ap-combobox-input-box .combobox-tag-wrapper .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag .ap-tag-label{font-weight:400}::ng-deep .ap-combobox .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3);background-color:var(--color-background-hover-selected);color:var(--color-text-body);width:max-content}::ng-deep .ap-combobox .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag .ap-tag-label{font-weight:400}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{margin-left:var(--spacing-3)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{margin-left:var(--spacing-2)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag:not(.combobox-tag-item){transform:translateY(-.0625rem)}::ng-deep .ap-combobox .ap-combobox-input-box.showOverflow.overflow-line .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag.combobox-tag-item{margin-bottom:0}::ng-deep .ap-combobox.disabled .ap-combobox-input-box .ap-tag.ap-tag-default.combobox-tag.combobox-tag-item{background-color:var(--color-background-hover-selected);color:var(--color-text-body)}::ng-deep .ap-combobox.error .ap-combobox-input-box .ap-tag.ap-tag-default.combobox-tag.combobox-tag-item{background-color:var(--color-background-danger);color:var(--color-text-secondary)}.ap-combobox{position:relative}.ap-combobox .ap-combobox-input-box{position:relative;display:flex;width:100%;height:3rem;background-color:var(--color-background-container);border-radius:var(--border-radius-2);box-shadow:inset 0 0 0 .0625rem var(--color-background-border);overflow:hidden;box-sizing:border-box;align-items:center}.ap-combobox .ap-combobox-input-box.showOverflow{flex-wrap:wrap;width:unset;min-height:3rem;line-height:3rem;height:unset!important;justify-content:unset}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container{width:calc(100% - 6rem);display:flex;overflow-y:auto}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container.no-items,.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container.no-items .ap-combobox-input-box-items{width:100%}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container .ap-combobox-input-box-items{display:flex;flex-wrap:wrap;padding-left:var(--spacing-2);align-items:flex-end}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input-box-container::-webkit-scrollbar{display:none}.ap-combobox .ap-combobox-input-box .ap-combobox-input{width:100%;padding:var(--spacing-4) var(--spacing-8) var(--spacing-4) var(--spacing-3);height:3rem;color:var(--color-text-body);font-size:1rem;letter-spacing:-.025rem;line-height:1.5rem;background-color:transparent;outline:0!important;position:absolute}.ap-combobox .ap-combobox-input-box .ap-combobox-input.input-width{position:unset}.ap-combobox .ap-combobox-input-box .ap-combobox-input.exceedPadding{padding-right:6rem}.ap-combobox .ap-combobox-input-box .ap-combobox-input+label{position:absolute;left:var(--spacing-3);top:var(--spacing-4);color:var(--color-text-light);font-size:1rem;line-height:1.5rem;letter-spacing:-.025rem}.ap-combobox .ap-combobox-input-box .ap-combobox-input[required]+label:after{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;background-color:var(--color-text-error);border-radius:50%}.ap-combobox .ap-combobox-input-box.overflow-line{line-height:1.75rem}.ap-combobox .ap-combobox-input-box.overflow-line .ap-combobox-input{height:1.75rem;line-height:1.75rem}.ap-combobox .ap-combobox-input-box.overflow-line .ap-combobox-input-box-items{padding-top:var(--spacing-3);padding-bottom:var(--spacing-4)}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-clear-icon{top:unset!important}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input{position:inherit;padding:0;margin-left:var(--spacing-2);display:block}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.input-width{width:.25rem}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.select-all{width:inherit}.ap-combobox .ap-combobox-input-box.showOverflow .ap-combobox-input.exceedPadding{padding-right:0}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon{position:absolute;top:var(--spacing-2);right:3.3125rem;border-radius:var(--border-radius-2);visibility:hidden;display:flex;justify-content:center}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline{width:2.5rem;height:2.5rem;line-height:2.5rem;cursor:pointer;color:var(--color-text-body)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline.disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline.readonly{cursor:not-allowed}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline:not(.disabled):not(.error):hover{cursor:pointer;border-radius:var(--border-radius-2);background-color:var(--color-background-hover-selected)}.ap-combobox .ap-combobox-input-box .ap-combobox-clear-icon.showDeleteIcon{visibility:visible}.ap-combobox .ap-combobox-input-box .separte-line{position:absolute;display:inline-block;top:var(--spacing-3);right:2.875rem;width:.0625rem;height:calc(100% - 1rem);border-radius:.03125rem;background-color:#d1d1d1}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline{position:absolute;right:var(--spacing-2);top:0;width:2.5rem;height:100%;line-height:100%;border-radius:var(--border-radius-1);transform:rotate(0);transition:transform .3s;color:var(--color-text-body)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.up{transform:rotate(-180deg)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline.readonly{cursor:not-allowed}.ap-combobox .ap-combobox-input-box .icon-down-chevron-outline:not(.disabled):hover{cursor:pointer}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-input::placeholder{color:rgba(var(--color-text-light-rgb),var(--opacity-5))}.ap-combobox .ap-combobox-dropdown-list{z-index:99;position:absolute;display:block;width:100%;top:3.5rem;left:0;padding:var(--spacing-3);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container);color:var(--color-text-body);transform:translateY(.75rem);visibility:hidden;opacity:0;max-height:17.5rem;overflow:auto}.ap-combobox .ap-combobox-dropdown-list.open{visibility:visible;opacity:1;transform:translateY(0);transition:visibility .3s,opacity .3s,transform .3s;pointer-events:auto}.ap-combobox .ap-combobox-dropdown-list.hide{visibility:hidden;animation-fill-mode:both;transition:all .3s ease-in-out}.ap-combobox .ap-combobox-dropdown-list .ap-option-item{position:relative;width:100%;height:3rem;margin-bottom:var(--spacing-2);padding:var(--spacing-4) var(--spacing-3);border-radius:var(--border-radius-2);cursor:pointer;display:flex;justify-content:space-between;align-items:center;line-height:1.5rem;color:var(--color-text-body)}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult{justify-content:center;margin-bottom:0!important}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult:hover{cursor:auto;background-color:var(--color-background-container)}.ap-combobox .ap-combobox-dropdown-list .ap-option-item.noResult .ap-option-label{padding-right:0}.ap-combobox.disabled{cursor:not-allowed}.ap-combobox.disabled .ap-combobox-input-box{cursor:not-allowed;pointer-events:none;box-shadow:inset 0 0 0 .0625rem rgba(var(--color-background-border-rgb),var(--opacity-6))}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-input{cursor:not-allowed;color:rgba(var(--color-text-heading-rgb),var(--opacity-5))}.ap-combobox.disabled .ap-combobox-input-box .ap-combobox-clear-icon .icon-circle-delete-outline{color:rgba(var(--color-text-light-rgb),var(--opacity-5))}.ap-combobox.disabled .ap-combobox-input-box .separte-line{opacity:var(--opacity-5)}.ap-combobox.readonly{cursor:not-allowed}.ap-combobox.readonly .ap-combobox-input-box{pointer-events:none;cursor:not-allowed;box-shadow:inset 0 0 0 .0625rem var(--color-background-border)}.ap-combobox.readonly .ap-combobox-input-box .ap-combobox-input{pointer-events:none;color:var(--color-text-heading);opacity:var(--opacity-6)}.ap-combobox.readonly .ap-combobox-input-box .ap-combobox-clear-icon,.ap-combobox.readonly .ap-combobox-input-box .icon-down-chevron-outline{opacity:var(--opacity-6);pointer-events:none}.ap-combobox.error .ap-combobox-input-box{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3));box-shadow:inset 0 0 0 .0625rem var(--color-background-danger)}.ap-combobox.error .ap-combobox-input-box:focus-within:not(.keyboard-focus){box-shadow:0 0 0 .0625rem var(--color-background-danger),0 0 0 .25rem rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}.ap-combobox.error .ap-combobox-input-box .ap-combobox-input{color:var(--color-text-body)}.ap-combobox.error .ap-combobox-input-box .ap-combobox-clear-icon:hover{border-radius:var(--spacing-2);background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}.ap-combobox:not(.disabled):not(.readonly) .ap-combobox-input-box:focus-within:not(.keyboard-focus){box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}.ap-combobox:not(.disabled):not(.readonly) .ap-combobox-input-box:focus-within.keyboard-focus{outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}.ap-combobox:not(.disabled):not(.readonly):not(.error) .ap-combobox-input-box:hover{background-color:var(--color-background-hover)}.ap-combobox .search-result{border:0;clip:rect(0px,0px,0px,0px);height:.0625rem;margin-bottom:-.0625rem;margin-right:-.0625rem;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:.0625rem}.ap-combobox .loading-container{display:flex;justify-content:center;align-items:center;height:4rem;width:100%}::ng-deep .ap-combobox.error .ap-combobox-input-box .ap-tag.ap-tag-default.ap-tag-sm.combobox-tag{background-color:var(--color-background-danger);color:var(--color-text-tertiary)}\n"] }]
        }], ctorParameters: () => [{ type: i1.DropdownService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i2.LocalizationConfig }], propDecorators: { inputViewChild: [{
                type: ViewChild,
                args: ["comboboxInput"]
            }], iconChevron: [{
                type: ViewChild,
                args: ["iconChevron"]
            }], comboboxListItemArray: [{
                type: ContentChildren,
                args: [DropdownListItemComponent]
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], error: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], selectType: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], optionName: [{
                type: Input
            }], optionValue: [{
                type: Input
            }], list: [{
                type: Input
            }], listId: [{
                type: Input
            }], comboboxId: [{
                type: Input
            }], showDeleteIcon: [{
                type: Input
            }], showSelectAll: [{
                type: Input
            }], noResultMsg: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], resultStatus: [{
                type: Input
            }], showMultipleTags: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], showLoading: [{
                type: Input
            }], showAllSelectedTag: [{
                type: Input
            }], onClose: [{
                type: Output
            }], onSelect: [{
                type: Output
            }], onFilterResult: [{
                type: Output
            }], comboboxList: [{
                type: ViewChild,
                args: ["comboboxList"]
            }], inputBoxItems: [{
                type: ViewChild,
                args: ["inputBoxItems"]
            }], inputArea: [{
                type: ViewChild,
                args: ["inputArea"]
            }], secondaryDelIcon: [{
                type: ViewChild,
                args: ["secondaryDelIcon"]
            }] } });

class ComboboxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComboboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: ComboboxModule, declarations: [ComboboxComponent], imports: [CommonModule,
            FormsModule,
            TagModule,
            DropdownListItemModule,
            LoadingModule], exports: [ComboboxComponent,
            DropdownListItemModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComboboxModule, providers: [DropdownService], imports: [CommonModule,
            FormsModule,
            TagModule,
            DropdownListItemModule,
            LoadingModule, DropdownListItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComboboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        TagModule,
                        DropdownListItemModule,
                        LoadingModule
                    ],
                    exports: [
                        ComboboxComponent,
                        DropdownListItemModule
                    ],
                    declarations: [ComboboxComponent],
                    providers: [DropdownService]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { COMBOBOX_VALUE_ACCESSOR, ComboboxComponent, ComboboxModule };
